import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/course-sessions/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const sessions = {
  getAll: apiPathFunc(pathBase),
} as const;
